<div *ngIf="dialogData?.events?.length" class="flex flex-col gap-6">
  <div class="flex justify-between items-center">
    <h3>{{ dialogData?.events.length }} booking conflicts</h3>
    <sbnb-close mat-dialog-close></sbnb-close>
  </div>

  <div class="flex flex-col gap-3" *ngFor="let event of dialogData?.events">
    <div class="flex gap-6 justify-between">
      <div class="flex gap-3 items-center">
        <img
          class="rounded hidden md:block"
          [src]="event.guest_thumbnail"
          onerror="this.src='/assets/images/profile-default.png'"
          width="40px"
          height="40px" />

        <div class="flex flex-col gap-1">
          <a (click)="openReservation(event)" class="flex gap-3 items-center link">
            <sbnb-truncate class="max-w-28" [text]="event.guest"></sbnb-truncate>

            <div class="hidden md:block">
              <img
                *ngIf="event.manual && event.channel !== 'manual' && event.channel !== 'other'"
                width="16px"
                height="16px"
                [src]="'/assets/iconography/manual.svg'"
                [alt]="event.channel"
                [matTooltip]="'Manual booking'" />

              <img
                *ngIf="event.channel"
                width="16px"
                height="16px"
                [src]="'/assets/iconography/' + (event.channel | lowercase) + '.svg'" />
            </div>
          </a>
          <sbnb-copy-to-clipboard [content]="event.code">
            <span class="night-lighter text__small">{{ event.code }}</span>
          </sbnb-copy-to-clipboard>
        </div>
      </div>
      <div class="flex flex-wrap gap-1 items-center justify-end flex-1">
        <strong class="text__small night" [matTooltip]="event.checkin_tooltip">
          {{ event.checkin_label }}
        </strong>
        <span class="night-lighter">&ndash;</span>
        <strong class="text__small night" [matTooltip]="event.checkout_tooltip">
          {{ event.checkout_label }}
        </strong>
      </div>
    </div>

    <mat-divider></mat-divider>
  </div>
</div>
